import type { RouteRecordRaw, Router } from 'vue-router'

const RentRoutes: RouteRecordRaw = {
  path: '/contract/financial/rent',
  name: 'RentModulePages',
  children: [
    {
      path: '',
      name: 'RentMainRoute',
      component: () => import('./views/RentView.vue'),
      meta: {
        title: 'rent.rentContract',
      },
    },
    {
      path: 'create',
      name: 'RentCreateRoute',
      component: () => import('./views/RentUpsertView.vue'),
      meta: {
        title: 'rent.createViewTitle',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:rentId',
      name: 'RentEditRoute',
      component: () => import('./views/RentUpsertView.vue'),
      meta: {
        title: 'rent.editViewTitle',
        pageHasBack: true,
      },
    },
    {
      path: 'renew/:rentId',
      name: 'RentRenewRoute',
      component: () => import('./views/RentUpsertView.vue'),
      meta: {
        title: 'renewContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:rentId',
      name: 'ViewRentRoute',
      component: () => import('./views/SingleRentView.vue'),
      meta: {
        title: 'rent.singleViewTitle',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(RentRoutes)
}
